
import { Quest, QuestCategory } from '../../../types';

export const CREATIVE_STITCHER_QUESTS: Quest[] = [
  {
    id: 1900,
    category: QuestCategory.SkillBuilder,
    title: 'Meet the Machine',
    questlineId: 'creative-stitcher',
    isQuestlineStart: true,
    description: 'Let\'s learn the basics of the most powerful tool in your new creative arsenal: the sewing machine.',
    details: 'With an adult, get to know your sewing machine. Learn how to thread it, how to turn it on, and identify the key parts: the needle, the presser foot, the foot pedal, and the hand wheel. This is your machine\'s "driver\'s test".'
  },
  {
    id: 1901,
    category: QuestCategory.SkillBuilder,
    title: 'Straight Line Driver',
    questlineId: 'creative-stitcher',
    prerequisiteQuestId: 1900,
    description: 'Before you can sew amazing shapes, you must master the straight line.',
    details: 'On a piece of scrap fabric, practice sewing straight lines. You can draw lines with a ruler to help guide you. The goal is to get a feel for controlling the speed with the foot pedal and guiding the fabric with your hands.'
  },
  {
    id: 1902,
    category: QuestCategory.Creator,
    title: 'Project: Pincushion',
    questlineId: 'creative-stitcher',
    prerequisiteQuestId: 1901,
    description: 'Time for your first real project! Let\'s create a simple but useful pincushion.',
    details: 'Using two small squares of fabric, you will sew your first 3D object. Sew around three sides, turn it right-side-out, stuff it, and then hand-sew the last side closed. You\'ve made a useful tool!'
  },
  {
    id: 1903,
    category: QuestCategory.Creator,
    title: 'Project: Drawstring Bag',
    questlineId: 'creative-stitcher',
    prerequisiteQuestId: 1902,
    description: 'Level up your skills by creating a simple drawstring bag for your treasures.',
    details: 'This project teaches you how to create a "channel" for the drawstring. It\'s a slightly more complex project that results in a very useful bag for holding toys, dice, or other small items.'
  },
  {
    id: 1904,
    category: QuestCategory.Creator,
    title: 'Project: Custom Patch',
    questlineId: 'creative-stitcher',
    prerequisiteQuestId: 1903,
    description: 'The final project: design and create your own custom patch to sew onto a jacket or bag.',
    details: 'Draw a design on paper, then cut the shapes out of felt. Use the sewing machine to stitch the layers together. You\'ve created a piece of wearable art that shows off your personality and new skills!'
  }
];
